import { getClassifyList } from '@cap/share/src/apis/home';

interface IOriginData {
  dimensionCode: string;
  dimensionName: string;
  pathList: ICourseClassify[];
}

export interface ICourseClassify {
  id: number;
  name: string;
  level: number;
  dimension: string;
  parentId: number;
  classifyPath: string;
  children?: ICourseClassify[];
  weight: number;
}

/**
 * treeDeep: 需要用到的树的层级，仅处理并返回到x层
 * hasAllNode: 是否添加「全部」节点
 */
interface IProps {
  treeDeep?: number;
  hasAllNode?: boolean;
}

interface ITreeListOptions {
  treeDeep: number;
  hasAllNode: boolean;
}

const ALL_NODE_DATA = { id: 0, name: '全部', weight: -1 };

const formatOriginData = (originData: IOriginData[]): ICourseClassify[] => {
  if (!originData?.length) return [];

  return originData.map((item, idx) => {
    const { dimensionCode, dimensionName, pathList } = item;
    return {
      id: idx,
      name: dimensionName,
      dimension: dimensionCode,
      level: -1,
      parentId: -1,
      classifyPath: '0',
      children: pathList,
      weight: -1,
    };
  });
};

const formatList2Tree = (originData: ICourseClassify[], options: ITreeListOptions) => {
  if (!originData?.length) return [];

  const { treeDeep, hasAllNode } = options;
  const map = new Map<number, ICourseClassify>();
  const result: ICourseClassify[] = [];
  originData.forEach((item) => {
    if (item.level > treeDeep) return;
    map.set(item.id, item);
    if (hasAllNode && !result.length) {
      const allNode = {
        ...ALL_NODE_DATA,
        level: item.level,
        dimension: item.dimension,
        parentId: item.parentId,
        classifyPath: '0',
      };
      result.push(allNode);
    }
    if (item.level === 1) {
      result.push(map.get(item.id)!);
    } else {
      const parent = map.get(item.parentId);
      if (!parent) return;
      if (!parent.children) {
        const allNode = {
          ...ALL_NODE_DATA,
          level: item.level,
          dimension: item.dimension,
          parentId: item.parentId,
          classifyPath: parent.classifyPath,
        };
        parent.children = hasAllNode ? [allNode] : [];
      }
      parent.children.push(map.get(item.id)!);
    }
  });
  result.sort((a, b) => a.weight - b.weight);
  result.forEach((item) => {
    item?.children?.sort((a, b) => a.weight - b.weight);
  });
  return result;
};

export default function useCourseClassify(props?: IProps) {
  const { treeDeep = 2, hasAllNode = false } = props || {};
  const getBaseData = async () => {
    try {
      const res = await getClassifyList<IOriginData[]>();
      return formatOriginData(res.data);
    } catch (error) {
      return [];
    }
  };

  const getClassifyTree = async (): Promise<ICourseClassify[]> => {
    const baseData = await getBaseData();
    return baseData.map((item) => {
      return {
        ...item,
        children: formatList2Tree(item.children || [], { treeDeep, hasAllNode }),
      };
    });
  };

  return {
    getClassifyTree,
  };
}
